import '../App.css';
import '../scss/App.scss';
import { Box, Container, Grid, Link, Button, TextField, IconButton, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, } from '@mui/material';
import { useEffect, useState, useRef } from 'react';
import axios from 'axios'; // If you're using axios
import { useParams } from 'react-router-dom';
import { Typography } from '@mui/material';
import SEO from '../seo/SEO';

function DwarkadhishTemple({ onSave }) {

  const [templeData, setTempleData] = useState(null);
  const [weather, setWeather] = useState([]);
  




  const carouselItems = [
    {
      title: "Helicopter Services",
      image: "../assets/service-slider/amarnath-helicopter.svg",
      content: [
        {
          title: ["Baltal-Panjtarni: ₹3000–₹5000/person.",<br />,"Pahalgam-Panjtarni: ₹2000–₹4000/person."],
          prices: []
        }
      ]
    },
    {
      title: "Ponies/Palkis",
      image: "../assets/service-slider/amarnath-palki.svg",
      content: [
        "₹1000–₹2000/person (one way).",
      ]
    },

    {
      title: "Ropeway (Upcoming)",
      image: "../assets/service-slider/amarnath-ropeway.svg",
      content: [
        "9 km from Baltal to shrine.",
      ]
    },
  
  ];

  const weatherImg = [
    {
      image: "../assets/march-june.svg",
    },
    {
      image: "../assets/july-sept.svg",
    },
    {
      image: "../assets/oct-nov.svg",
    },
    {
      image: "../assets/dec-feb.svg",
    },
  ];
  const initialDescription = 'Demo text goes here.';
  const [description, setDescription] = useState(initialDescription);
  const [isEditing, setIsEditing] = useState(false);

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleSaveClick = () => {
    setIsEditing(false);
    if (onSave) {
      onSave(description); // Optionally update to API or parent state
    }
  };

  useEffect(() => {
    if (templeData?.sections?.[0]?.description) {
      setDescription(templeData.sections[0].description);
    }
  }, [templeData]);

  const mergedWeather = weather.map((item, index) => ({
    ...item,
    image: weatherImg[index]?.image || "/assets/default-placeholder.svg",
  }));

  const [openModal, setOpenModal] = useState(false);
  const [modalContent, setModalContent] = useState('');

  const getTruncatedText = (text, wordLimit = 24) => {
    const words = text.split(' ');
    if (words.length <= wordLimit) return text;
    return words.slice(0, wordLimit).join(' ') + '...';
  };

  const handleReadMore = (fullText) => {
    setModalContent(fullText);
    setOpenModal(true);
  };
  return (
    <>
      <SEO pageKey="dwarkadhish" />
      <Box className="innerbanner" >
        <img src="../assets/banner/dwarkadhish-image.svg" alt="" />
        <Box className="innerContent">
          <h1>Dwarkadhish Temple</h1>
        </Box>
      </Box>
      <Box className="templeDetailBox">
        <Container maxWidth="md">
          <Grid container spacing={2} justifyContent="center" >
            <Grid size={{ xl: 8, lg: 8, md: 8, sm: 12, xs: 12 }} >
              <Box
                className="detailBoxContent"
                sx={{

                  position: 'relative',
                }}
              >
                <p className="mb-1">Dwarkadhish Temple, also known as Jagat Mandir, is a 2,500-year-old shrine dedicated to Lord Krishna in Dwarka, Gujarat. Believed to be originally built by Krishna’s great-grandson Vajranabh, the temple was rebuilt in the 15th-16th centuries after destruction by Mahmud Begada. This stunning five-story limestone structure features intricate carvings, a towering 78-meter spire, and a flag changed five times daily. As part of the Char Dham Yatra, pilgrims enter through the Swarg Dwar (Gateway to Heaven) and exit via the Moksha Dwar (Gateway to Liberation). Set at the confluence of the Gomti River and Arabian Sea, with a serene black marble idol of Krishna inside, the temple offers a divine blend of spirituality, history, and breathtaking views.</p>


              </Box>
            </Grid>
            <Grid size={{ xl: 4, lg: 4, md: 4, sm: 12, xs: 12 }} >
              <Box className="detailBoxImg">
                <img src="../assets/dwarkadhish-about.svg" alt="" className='img-fluid' />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <section>
        <Box className="tempratureBox">
          <Container maxWidth="md">
            <Grid container spacing={2} alignItems="center" justifyContent="center">
              <Grid size={12}>
                <Box className="templeInnerHeading">
                  <h2>Monthly Temperature Guide</h2>
                </Box>
              </Grid>

              <Grid size={{ xl: 4, lg: 4, md: 4, sm: 6, xs: 6 }}>
                <Box className="tempratureContentBox">
                  <img src="../assets/march-june.svg" alt="" className="w-100" />
                  <h3>
                     Summer
                    <br />
                    <span>25°C to 35°C</span>
                  </h3>
                </Box>
              </Grid>

                <Grid size={{ xl: 4, lg: 4, md: 4, sm: 6, xs: 6 }}>
                <Box className="tempratureContentBox">
                  <img src="../assets/dec-feb.svg" alt="" className="w-100" />
                  <h3>
                    Winter
                    <br />
                    <span>15°C to 25°C</span>
                  </h3>
                </Box>
              </Grid>
            
            

              

            </Grid>
          </Container>
        </Box>
      </section>
      <section>
        <Box className="tampleTimingBox">
          <Container maxWidth="md">
            <Grid container spacing={2} alignItems="stretch">
              <Grid size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }} >
                <Box className="tampleTimingImg">
                  <img src="../assets/dwarkadhish-timing.svg" className='img-fluid' alt="" />
                </Box>
              </Grid>
              <Grid size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }} >
                <Box className="tampleTimingContent grayBox p-lg-4">
                  <Box className="templeInnerHeading">
                    <h3>Temple Timings</h3>
                  </Box>
                  <ul>
                    <li>
                      Morning
                      <span>7:00 AM – 12:30 PM</span>
                    </li>

                    <li>
                      Evening
                      <span>5:00 PM – 9:00 PM</span>
                    </li>
                  </ul>


                  <Box className="templeInnerHeading mt-4">
                    <h3>Arti Timings</h3>
                  </Box>
                  <ul>
                    <li>
                      Mangla Arti
                      <span>6:00 AM</span>
                    </li>

                    <li>
                      Shringar Arti
                      <span>10:30 AM – 10:45 AM</span>
                    </li>
                    <li>
                      Sandhya Arti
                      <span> 7:30 PM – 7:45 PM</span>
                    </li>
                    <li>
                      Shayan Arti
                      <span>8:30 PM – 8:35 PM</span>
                    </li>
                  </ul>

                 
                  
                </Box>
              </Grid>
            </Grid>
            
           
          </Container>
        </Box>
      </section>
  
         <section className="lightGrayBox">
                <Container maxWidth="md">
              <Grid container spacing={2} alignItems="center" className="mt-4" justifyContent="center">
                <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
                  <Box className="templeInnerHeading">
                    <h2>Plan Your Route</h2>
                  </Box>
                </Grid>


                
                  <Grid size={{ xl: 12, lg: 12, md: 12, sm: 6, xs: 12 }} >
                    <Box className="routeBox">
                      <Box className="routeInnerBox">
                        <Box className="route1">
                          <img src="../assets/route-icon/flight.svg" alt="" className='img-fluid' />
                          <h3>Flight</h3>
                        </Box>
                        <Box className="route2">
                          <img src="../assets/route-icon/border.svg" alt="" className='img-fluid' />
                        </Box>
                        <Box className="route3">
                          <p>Jamnagar Airport (JGA) – ~45 km (28 miles)</p>
                        </Box>
                      </Box>


                      <Box className="routeInnerBox">
                        <Box className="route1">
                          <img src="../assets/route-icon/train.svg" alt="" className='img-fluid' />
                          <h3>Train</h3>
                        </Box>
                        <Box className="route2">
                          <img src="../assets/route-icon/border.svg" alt="" className='img-fluid' />
                        </Box>
                        <Box className="route3">
                          <p>Dwarka Railway Station (DWK)</p>
                        </Box>
                      </Box>

                      <Box className="routeInnerBox">
                        <Box className="route1">
                          <img src="../assets/route-icon/bus.svg" alt="" className='img-fluid' />
                          <h3>Bus</h3>
                        </Box>
                        <Box className="route2">
                          <img src="../assets/route-icon/border.svg" alt="" className='img-fluid' />
                        </Box>
                        <Box className="route3">
                          <p> Dwarka Bus Stand</p>
                        </Box>
                      </Box>


                      <Box className="routeInnerBox">
                        <Box className="route1">
                          <img src="../assets/route-icon/auto.svg" alt="" className='img-fluid' />
                          <h3>Auto Fare (Round Trip)</h3>
                        </Box>
                        <Box className="route2">
                          <img src="../assets/route-icon/border.svg" alt="" className='img-fluid' />
                        </Box>
                        <Box className="route3">
                          <p>₹200–300 (approx.)</p>
                        </Box>
                      </Box>
                      
                    </Box>
                  </Grid>
                


              </Grid>
              </Container>
            </section>

      <section>
        <Container maxWidth="md">
          <Grid container spacing={2} justifyContent="center" alignItems="center">
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <Box className="templeInnerHeading">
                <h2>Visitor Statistics (Days & Monthly)</h2>
              </Box>


            </Grid>
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <Box className="templeInnerHeading mb-4">
                <h3 className='heighLightText'>Peak and <span>Off-Season</span></h3>
                <p>(visitors/month)</p>
              </Box>
            </Grid>
            
              <Grid size={{ xl: 2.4, lg: 2.4, md: 2.4, sm: 6, xs: 6 }} >
                <Box className="peakMonthBox">
                  <Box>
                    <p>Peak Days</p>
                    <span>30k - 40k</span>
                  </Box>
                </Box>
              </Grid>

               <Grid size={{ xl: 2.4, lg: 2.4, md: 2.4, sm: 6, xs: 6 }} >
                <Box className="peakMonthBox">
                  <Box>
                    <p>Peak Months</p>
                    <span>3 Lac</span>
                  </Box>
                </Box>
              </Grid>

             

              <Grid size={{ xl: 2.4, lg: 2.4, md: 2.4, sm: 6, xs: 6 }} >
                <Box className="offPeakMonthBox">
                  <Box>
                    <p>Normal Months</p>
                    <span>2.5 Lac</span>
                  </Box>
                </Box>
              </Grid>

              <Grid size={{ xl: 2.4, lg: 2.4, md: 2.4, sm: 6, xs: 6 }} >
                <Box className="offPeakMonthBox">
                  <Box>
                    <p>Normal Days</p>
                    <span>20k - 30k</span>
                  </Box>
                </Box>
              </Grid>

              
             
            

        
          </Grid>
        </Container>
      </section>



      <Box className="lightGrayBox">
        <Container maxWidth="md">
          <Grid container spacing={2} justifyContent="center" alignItems="center">
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <Box className="templeInnerHeading mb-lg-4">
                <h2>Accommodation Information</h2>
              </Box>
            </Grid>
            
              <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                <Box className="accommodationBox">
                  <Box className="accommodationImg">
                    <img src="/assets/accommodation-icon/icon7.svg" className='img-fluid' alt="" />
                  </Box>
                  <Box className="accommodationContent">
                    <h3>Nearby Cities</h3>
                    <p className='mb-0'>Porbandar (95 km) and Jamnagar (145 km)</p>
                  </Box>
                </Box>
              </Grid>

              <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                <Box className="accommodationBox">
                  <Box className="accommodationImg">
                    <img src="/assets/accommodation-icon/icon1.svg" className='img-fluid' alt="" />
                  </Box>
                  <Box className="accommodationContent">
                    <h3>Tariffs</h3>
                    <p className='mb-0'><span>Dormitory:</span> From ₹150</p>
                    <p className='mb-0'><span>2-Bed AC Room:</span> From ₹10,000</p>
                    <p className='mb-0'><span>Basic Hotels:</span> From ₹100</p>
                  </Box>
                </Box>
              </Grid>
              
            

          </Grid>
        </Container>
      </Box>

      <section>
        <Container maxWidth="md">
          <Grid container spacing={2} justifyContent="center" alignItems="center">
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <Box className="templeInnerHeading mb-lg-4">
                <h2>Here’s What You Should Know</h2>
              </Box>
            </Grid>
            
          

           
            <Grid size={{ xl: 7, lg: 8, md: 8, sm: 12, xs: 12 }} >
              <div className='infoGuideBox'>
                <Grid container spacing={2} justifyContent="center" alignItems="center">
                  <Grid size={{ xl: 5, lg: 5, md: 5, sm: 12, xs: 12 }} >
                    <div className='infoHeading'>

                      <h2>01</h2>
                      <h3>Paid parking</h3>

                    </div>
                  </Grid>

                  <Grid size={{ xl: 7, lg: 7, md: 7, sm: 12, xs: 12 }} >
                    <div className='infoList'>

                      <p className='mb-0'>Parking is within 300mtrs </p>
                    </div>
                  </Grid>
                </Grid>
              </div>



            </Grid> 


           


            



          

           


           
          </Grid>
        </Container>
      </section>



 {/* <Grid size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }} >
              <div className='infoGuideBox'>
                <Grid container spacing={2} justifyContent="center" alignItems="center">
                  <Grid size={{ xl: 5, lg: 5, md: 5, sm: 12, xs: 12 }} >
                    <div className='infoHeading'>

                      <h2>02</h2>
                      <h3>Nearby Attractions</h3>

                    </div>
                  </Grid>

                  <Grid size={{ xl: 7, lg: 7, md: 7, sm: 12, xs: 12 }} >
                    <div className='infoList'>

                      <p className='mb-0'><span>Betaab Valley, Aru Valley</span> (near Pahalgam).</p>
                    </div>
                  </Grid>
                </Grid>
              </div>



            </Grid> */}
      <section className="lightGrayBox">
        <Container maxWidth="md">
          <Grid container spacing={2} justifyContent="center" alignItems="center">
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <Box className="templeInnerHeading mb-lg-4">
                <h2>Explore Nearby</h2>
              </Box>
            </Grid>
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <Box className="explore-nearby">
                <Grid container spacing={2}>
                  {/* Left Column */}
                  <Grid size={{ xl: 7, lg: 7, md: 7, sm: 12, xs: 12 }}>
                    <Box className="info-box">
                      <Typography className="title">Tourist Attractions</Typography>
                      <div className="block">
                        <p>Dwarka Beach</p>
                        <p>Bet Dwarka</p>
                        <p>Rukmini Devi Temple</p>
                        <p>Nageshwar</p>
                        <p>Jyotirling</p>
                      </div>
                     
                    </Box>

                    <Box className="info-box mt-3">
                      <Typography className="title">Nearby ATMs</Typography>
                      <p>HDFC Bank ATM</p>
                      <p>Axis Bank ATM</p>
                    </Box>

                    <Box className="info-box mt-3">
                      <Typography className="title">Hospitals Nearby</Typography>
                      <p>Dwarka Hospital – 1.5 km</p>
                      <p>Lifeline Hospital – 3 km</p>
                    </Box>

                    
                  </Grid>

                  {/* Right Column */}
                  <Grid size={{ xl: 5, lg: 5, md: 5, sm: 12, xs: 12 }}>
                    <Grid container spacing={2}>
                      <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
                        <Box className="info-box">
                          <Typography className="title">Medical Stores</Typography>
                          <p>Dwarka Medical Store (0.4 km)</p>
                          <p>Vishnu Pharmacy (0.3 km)</p>
                        </Box>
                      </Grid>
                      <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
                        <Box className="info-box">
                          <Typography className="title">Food</Typography>
                          <p>Dwarka Food Court (0.4 km)</p>
                          <p>Vishnu Bhojanalaya (0.3 km)</p>
                        </Box>
                      </Grid>
                      <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
                        <Box className="info-box">
                          <Typography className="title">Facilities</Typography>
                          <p><span>Cloak Room</span> Available</p>
                          <p><span>Toilets</span> Available</p>
                          <p><span>Drinking Water</span> Available</p>
                        </Box>
                      </Grid>
                      
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </Grid>

          </Grid>
        </Container>
      </section>


    

    


    </>
  );
}
export default DwarkadhishTemple;